


















































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import {Notify} from '@/utils/Notify';

import SystemInfoStore from '@/store/system/SystemInfo.store';
import NetworkDevicesStore from '@/store/network/NetworkDevices.store';
import LoraHardwareStore from '@/store/lora/LoraHardware.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import Widget from '@/components/Utils/Widget.vue';

@Component({
  components: {Widget},
})
export default class LoraQuickInfo extends Mixins<BaseComponent>(BaseComponent) {
  private loraHardwareStore: LoraHardwareStore = getModule(LoraHardwareStore, this.$store);

  private systemInfo: SystemInfoStore = getModule(SystemInfoStore, this.$store);

  private deviceStore: NetworkDevicesStore = getModule(NetworkDevicesStore, this.$store);

  private uppercase: boolean = false;

  private async mounted() {
    await this.refresh();
  }

  get mac(): string | undefined {
    return this.deviceStore.EthernetDevices?.find((d) => d.Id === 'eth0')?.HardwareAddress;
  }

  get serial(): string | undefined {
    return this.uppercase ? this.systemInfo.SystemInfo?.Serial.toUpperCase() : this.systemInfo.SystemInfo?.Serial.toLowerCase();
  }

  get copyEnabled(): boolean {
    return !!navigator.clipboard;
  }

  private async refresh() {
    this.setLoading();
    try {
      try {
        await this.loraHardwareStore.fetchRegion();
        await this.loraHardwareStore.fetchAntenna();
      } catch (error) {
        Notify.Error(this.logger, `Could not get lora hardware information`, error);
      }

      try {
        await this.systemInfo.fetchSystemInfo();
      } catch (error) {
        Notify.Error(this.logger, `Could not get system information`, error);
      }

      try {
        await this.deviceStore.fetchDevice('eth0');
      } catch (error) {
        Notify.Error(this.logger, `Could not get MAC address`, error);
      }

    } finally {
      this.setLoaded();
    }
  }

  private async copy(text: string) {
    try {
      await navigator.clipboard.writeText(text);
      Notify.Info(this.logger, 'The text has been copied to your clipboard', [text]);
    } catch (error) {
      Notify.Error(this.logger, 'Error copying to the clipboard', error);
    }
  }
}
